<template>
  <div class="mt-2 wdw-attachments">
    <span v-for="file in files" v-bind:key="file.id" :id="attachmentId(file)" class="wdw-attachment" role="listitem">
      <a :href="file.url" :title="file.title" target="_blank">
        <template v-if="file.type == 'url'">
          <font-awesome-icon class="wider-fa" icon="globe" size="lg" fixed-width />
        </template>
        <template v-else>
          <font-awesome-icon class="wider-fa" icon="paperclip" size="lg" flip="horizontal" fixed-width />
        </template>
        <span v-dompurify-html="attachmentTitle(file)"></span>
      </a>
    </span>
  </div>
</template>

<script>
import useConverter from '@/composables/general/useConverter';

export default {
  name: 'Attachments',
  props: {
    files: {
      type: Array,
      required: true,
    },
  },

  setup() {
    const { bytesToHumanReadable } = useConverter();

    function attachmentTitle(attachment) {
      let title = attachment.title;
      if (attachment.size > 0) {
        title = title + ' (' + bytesToHumanReadable(attachment.size) + ')';
      }
      return title;
    }
    function attachmentId(attachment) {
      return 'wdw-attachment-' + attachment.id;
    }

    return {
      attachmentId,
      attachmentTitle,
    };
  },
};
</script>

<style scoped>
.wider-fa {
  width: 1.4em;
}

.wdw-attachment {
  padding-right: 7px;
}
</style>
